/**
 * Displays a server error message in a form and clears it on user input.
 *
 * @param {HTMLFormElement} form - The form element.
 * @param {string} errorText - The error message to display.
 */
export function handleFormError(form, errorText) {
	const messageBox = form.querySelector('.js-form-message');
	if (!messageBox) return;

	const text = errorText || 'Произошла ошибка, попробуйте ещё раз';
	messageBox.textContent = text;
	messageBox.classList.add('form-message--visible');

	const parentModal = form.closest('.js-modal');

	const clearFormError = () => {
		messageBox.textContent = '';
		messageBox.classList.remove('form-message--visible');

		form.removeEventListener('input', handleInput, true);
		parentModal?.removeEventListener('modalClose', handleModalClose);
	};

	const handleInput = () => {
		clearFormError();
	};

	const handleModalClose = () => {
		clearFormError();
	};

	form.addEventListener('input', handleInput, true);
	parentModal?.addEventListener('modalClose', handleModalClose);
}
